import { FormGroup, Input, Label } from 'reactstrap';

export interface LegalAgreementCheckboxProps {
  readonly legalAccepted: boolean;
  readonly setLegalAccepted: (accepted: boolean) => void;
  readonly className?: string;
}

export function LegalAgreementCheckbox({
  legalAccepted,
  setLegalAccepted,
  className,
}: LegalAgreementCheckboxProps) {
  return (
    <FormGroup check className={className}>
      <Input
        type="checkbox"
        name="legalAccepted"
        id="legalAccepted"
        required
        checked={legalAccepted}
        onChange={(e) => setLegalAccepted(e.target.checked)}
      />
      <Label for="legalAccepted" check>
        By checking the box, you acknowledge and agree to our{' '}
        <a
          href="https://www.fishwindowcleaning.com/terms-of-use"
          target="_blank"
          rel="noopener"
        >
          Terms of Use
        </a>{' '}
        and{' '}
        <a
          href="https://www.fishwindowcleaning.com/privacy-policy"
          target="_blank"
          rel="noopener"
        >
          Privacy Policy
        </a>
        . Please note that all payments are processed through a third-party
        payment provider and gateway provider, including but not limited to
        Evalon, Inc.
      </Label>
    </FormGroup>
  );
}
